export default {
  page: {
    title: 'Settings',
    subtitle: 'System',
  },
  tabs: {
    company: 'Company details',
    messages: 'Print texts',
    settings: 'System variables',
    accessControl: 'Access control',
  },
  accessControl: {
    tabs: {
      roles: 'Types',
      modules: 'Modules',
      users: 'Users',
    },
  },
  company: {
    form: {
      name: {
        label: 'Name',
        placeholder: 'Name',
      },
      bgColor: {
        label: 'Background color',
        hint: 'pdf',
        placeholder: 'Background',
      },
      fontColor: {
        label: 'Font color (default)',
        hint: 'pdf',
        placeholder: 'Font',
      },
      fontColor2: {
        label: 'Font color',
        hint: 'pdf',
        placeholder: 'Font',
      },
      titleColor: {
        label: 'Title color',
        hint: 'pdf',
        placeholder: 'Background',
      },
      cnpj: {
        label: 'CNPJ',
        placeholder: '00.000.000/0000-00',
      },
      email: {
        label: 'Email',
        placeholder: 'Email',
      },
      site: {
        label: 'Website',
        placeholder: 'Website',
      },
      instagram: {
        label: 'Instagram',
        placeholder: 'Instagram',
      },
      whatsapp1: {
        label: 'WhatsApp phone 1',
      },
      whatsapp2: {
        label: 'WhatsApp phone 2',
      },
      phone: {
        label: 'Landline',
        placeholder: 'Phone',
      },
      address: {
        label: 'Address',
        placeholder: 'Street, Ave, Lane',
      },
      number: {
        label: 'Number',
        placeholder: 'Number',
      },
      district: {
        label: 'Neighborhood',
      },
      city: {
        label: 'City',
      },
      state: {
        label: 'State',
      },
      zipcode: {
        label: 'ZIP code',
        placeholder: '00000-000',
      },
    },
  },
  messages: {
    form: {
      slogan: {
        label: 'Slogan',
        hint: 'Below the company name',
        placeholder: 'List below the logo in PDFs',
      },
      receipt: {
        label: 'Receipt message',
      },
      warranty: {
        label: 'Warranty message',
      },
      approbation: {
        label: 'Inspection message',
      },
      sendMessage: {
        label: 'Send message',
        hintEmail: '(email body)',
        hintWhatsapp: '(WhatsApp body)',
      },
      footer: {
        label: 'Footer message',
      },
    },
  },
  settings: {
    form: {
      warranty: {
        label: 'Default warranty period',
        placeholder: 'Year, month, days',
      },
      timeAlert: {
        label: 'Customer alert time',
        placeholder: 'Wait time in days',
      },
      logo: {
        label: 'Logo',
        chooseFile: 'Choose an image...',
      },
    },
  },
  roles: {
    card: {
      title: 'User type list',
    },
    placeholder: 'Add a new department',
  },
  permissions: {
    form: {
      roles: {
        label: 'User types',
      },
    },
    card: {
      title: 'Module list',
    },
    empty: 'Select a department',
    yes: 'Yes',
  },
  users: {
    card: {
      title: 'User list',
    },
    selectRole: 'Select a department',
    noContent: 'No users registered yet.',
  },
  alert: {
    companySaved: 'Settings saved successfully',
    messagesSaved: 'Messages saved successfully',
    settingsSaved: 'Variables saved successfully',
    roleSaved: 'Department saved successfully',
    roleChanged: 'Department changed successfully',
    permissionsSaved: 'Permissions saved successfully',
  },
};
